{
  "decrease": "縮小 {fieldLabel}",
  "increase": "放大 {fieldLabel}",
  "numberField": "數字欄位"
}
